export const arr = [
    {
        "id": 1,
        "name": "BASIC COMPUTER - (BC)",
        "course_info": "This essential course is designed to turn beginners into confident computer users. It covers everything from starting a PC to mastering the internet and professional documentation.",
        "eligibility_critaria": "Above 5yrs",
        "course_duration": "6 months",
        "syllabus_highlight": " MS Office- WORD, EXCEL, POWERPOINT",
        "fees_structure": {
            "one_time_amount" : " 2,832",
            "emi_total_amount" : " 3,540"  
        }
    },
    {
        "id": 2,
        "name": "Advanced Computer Education - (ACE)",
        "course_info": "Elevate your digital proficiency with this advanced module. You will master complex data management, professional office automation, and advanced presentation skills.",
        "eligibility_critaria": "Above 13yrs+",
        "course_duration": "6 months",
        "syllabus_highlight": "MS Office- Advanced - WORD, EXCEL, POWERPOINT",
        "fees_structure": {
            "one_time_amount" : "4,248",
            "emi_total_amount" : "4,946"  
        }
    },
    {
        "id": 3,
        "name": "CERTIFICATE IN FINANCIAL ACCOUNTING (CFA)",
        "course_info": "Kickstart your career in the world of finance with our fundamental accounting course. You will learn the core principles of digital bookkeeping and how to use TallyPrime.",
        "eligibility_critaria": "Above 13yrs+)",
        "course_duration": "6 months ",
        "syllabus_highlight": "Fundamental of Accounting & Tally Prime Cost Center & Cost Category GST Fundamentals- Purchase & Sale entry syetem",
        "fees_structure": {
            "one_time_amount" : "5,900",
            "emi_total_amount" : "7,080"  
        }
    },
    {
        "id": 4,
        "name": "Advanced Financial Accounting (AFA)",
        "course_info": "Take your accounting skills to an expert level by mastering Indian taxation and corporate compliance, including GST and TDS.",
        "eligibility_critaria": "Above 13yrs+ and CFA Certified",
        "course_duration": "6 months",
        "syllabus_highlight": "Advanced Tally- Interest Calculation, Manufacturing, Payroll, TDS Etc E-Filling-  GST, IT Return",
        "fees_structure": {
            "one_time_amount" : "7,080",
            "emi_total_amount" : "8,260"  
        }
    },
    {
        "id": 5,
        "name": "CERTIFICATE IN GRAPHICS DESIGN (CGD)",
        "course_info": "Unleash your creativity with our foundational graphics course. Learn visual storytelling by mastering industry-standard tools like Photoshop and Canva",
        "eligibility_critaria": "Above 13yrs+",
        "course_duration": "6 months",
        "syllabus_highlight": "Fundamental of Graphics Design - Page Maker Basic to Advanced Photoshop Canva utilization",
        "fees_structure": {
            "one_time_amount" : " 5,900",
            "emi_total_amount" : "7,080"  
        }
    },
    {
        "id": 6,
        "name": "Advanced Graphics Design (AGD)",
        "course_info": "Transition from a designer to a visual artist with our advanced program. Dives deep into vector illustration and professional publishing layouts. Corel Draw, Illustrator etc.",
        "eligibility_critaria": "Above 13yrs+ and CGD Certified",
        "course_duration": "6 months",
        "syllabus_highlight": "Vector Graphics Design - Basic to Advanced illustration Corel Draw Adobe In-design",
        "fees_structure": {
            "one_time_amount" : "7,080",
            "emi_total_amount" : "8,260"  
        }
    },
    {
        "id": 7,
        "name": "Certificate in Web Designing (CWD)",
        "course_info": "Enter the world of web development by learning how to build modern websites from scratch focusing on responsive layouts.",
        "eligibility_critaria": "Above 13yrs+",
        "course_duration": "6 months",
        "syllabus_highlight": "Fundamental of Web Design - HTML CSS dream Weaver Visual Studio Git Hub Live Projects by using HTM & CSS",
        "fees_structure": {
            "one_time_amount" : "7,080",
            "emi_total_amount" : "8,260"  
        }
    },
    {
        "id": 8,
        "name": "Advanced Web Designing (AWD)",
        "course_info": "Upgrade your web skills by adding interactivity with JavaScript, Bootstrap, and WordPress CMS platforms.",
        "eligibility_critaria": "Above 13yrs+ and CWD Certified",
        "course_duration": "6 months",
        "syllabus_highlight": "Advanced Web Design - HTML CSS Java Script J Query Bootstrap Word Press Live Projects by using HTM,CSS, JS,Jqery, Bootstrap",
        "fees_structure": {
            "one_time_amount" : "8,260",
            "emi_total_amount" : "9,440"  
        }
    },
    {
        "id": 9,
        "name": "CERTIFICATE IN GENERATIVE AI (CGAI)",
        "course_info": "Stay ahead of the curve with our most modern course. Learn how to use AI tools like ChatGPT to automate tasks and solve problems faster.",
        "eligibility_critaria": "Above 13yrs+ and BASIC COMPUTER Certified",
        "course_duration": "3 Months",
        "syllabus_highlight": "AI Generation - Photo, Video, Audio, Web site advanced Excel problem solving",
        "fees_structure": {
            "one_time_amount" : "2,360",
            "emi_total_amount" : "2,596"  
        }
    }
]